const ClientActionTypes = {
    START: 'START',
    LOGOUT: 'LOGOUT',
    UPDATE_TEXT: 'UPDATE_TEXT',

    OPEN_DIALOG: 'OPEN_DIALOG',
    CLOSE_DIALOG: 'CLOSE_DIALOG',

    CHOOSE_MENU_START: 'CHOOSE_MENU_START',
    CHOOSE_MENU_FINISH: 'CHOOSE_MENU_FINISH',

    LOGIN_START: 'LOGIN_START',
    LOGIN_FINISH: 'LOGIN_FINISH',
    LOGIN_FAILED: 'LOGIN_FAILED',

    VERIFY_CPF_START: 'VERIFY_CPF_START',
    VERIFY_CPF_FINISH: 'VERIFY_CPF_FINISH',
    VERIFY_CPF_FAILED: 'VERIFY_CPF_FAILED',
    VERIFY_CPF_NOT_FOUND: 'VERIFY_CPF_NOT_FOUND',

    PRINT_BADGE_START: 'PRINT_BADGE_START',
    PRINT_BADGE_FINISH: 'PRINT_BADGE_FINISH',
    PRINT_BADGE_FAILED: 'PRINT_BADGE_FAILED',

    LINK_COURSEWARE_START: 'LINK_COURSEWARE_START',
    LINK_COURSEWARE_FINISH: 'LINK_COURSEWARE_FINISH',
    LINK_COURSEWARE_FAILED: 'LINK_COURSEWARE_FAILED',

    PRINT_TICKET_START: 'PRINT_TICKET_START',
    PRINT_TICKET_FINISH: 'PRINT_TICKET_FINISH',
    PRINT_TICKET_FAILED: 'PRINT_TICKET_FAILED',

    UPDATE_TOKEN_START: 'UPDATE_TOKEN_START',
    UPDATE_TOKEN_FINISH: 'UPDATE_TOKEN_FINISH',
    UPDATE_TOKEN_FAILED: 'UPDATE_TOKEN_FAILED',

    SELECT_COUNTRIES_START: 'SELECT_COUNTRIES_START',
    SELECT_COUNTRIES_FINISH: 'SELECT_COUNTRIES_FINISH',
    SELECT_COUNTRIES_FAILED: 'SELECT_COUNTRIES_FAILED',

    SELECT_CITIES_START: 'SELECT_CITIES_START',
    SELECT_CITIES_FINISH: 'SELECT_CITIES_FINISH',
    SELECT_CITIES_FAILED: 'SELECT_CITIES_FAILED',

    SELECT_EVENTS_START: 'SELECT_EVENTS_START',
    SELECT_EVENTS_FINISH: 'SELECT_EVENTS_FINISH',
    SELECT_EVENTS_FAILED: 'SELECT_EVENTS_FAILED',

    SELECT_PERMISSIONS_START: 'SELECT_PERMISSIONS_START',
    SELECT_PERMISSIONS_FINISH: 'SELECT_PERMISSIONS_FINISH',
    SELECT_PERMISSIONS_FAILED: 'SELECT_PERMISSIONS_FAILED',

    SELECT_PROFILES_START: 'SELECT_PROFILES_START',
    SELECT_PROFILES_FINISH: 'SELECT_PROFILES_FINISH',
    SELECT_PROFILES_FAILED: 'SELECT_PROFILES_FAILED',

    SELECT_USERS_START: 'SELECT_USERS_START',
    SELECT_USERS_FINISH: 'SELECT_USERS_FINISH',
    SELECT_USERS_FAILED: 'SELECT_USERS_FAILED',

    SELECT_EVENT_START: 'SELECT_EVENT_START',
    SELECT_EVENT_FINISH: 'SELECT_EVENT_FINISH',
    SELECT_EVENT_FAILED: 'SELECT_EVENT_FAILED',

    GET_SELECTED_EVENT_START: 'GET_SELECTED_EVENT_START',
    GET_SELECTED_EVENT_FINISH: 'GET_SELECTED_EVENT_FINISH',
    GET_SELECTED_EVENT_FAILED: 'GET_SELECTED_EVENT_FAILED',

    SELECT_COURSES_START: 'SELECT_COURSES_START',
    SELECT_COURSES_FINISH: 'SELECT_COURSES_FINISH',
    SELECT_COURSES_FAILED: 'SELECT_COURSES_FAILED',

    SELECT_CENTERS_START: 'SELECT_CENTERS_START',
    SELECT_CENTERS_FINISH: 'SELECT_CENTERS_FINISH',
    SELECT_CENTERS_FAILED: 'SELECT_CENTERS_FAILED',

    IMPORT_SHEET_START: 'IMPORT_SHEET_START',
    IMPORT_SHEET_FINISH: 'IMPORT_SHEET_FINISH',
    IMPORT_SHEET_FAILED: 'IMPORT_SHEET_FAILED',

    IMPORT_SHEET_PRODUCTS_START: 'IMPORT_SHEET_PRODUCTS_START',
    IMPORT_SHEET_PRODUCTS_FINISH: 'IMPORT_SHEET_PRODUCTS_FINISH',
    IMPORT_SHEET_PRODUCTS_FAILED: 'IMPORT_SHEET_PRODUCTS_FAILED',

    SELECT_RELATORIO_DASHBOARD_START: 'SELECT_RELATORIO_DASHBOARD_START',
    SELECT_RELATORIO_DASHBOARD_FINISH: 'SELECT_RELATORIO_DASHBOARD_FINISH',
    SELECT_RELATORIO_DASHBOARD_FAILED: 'SELECT_RELATORIO_DASHBOARD_FAILED',

    SELECT_VENDAS_TOTAIS_START: 'SELECT_VENDAS_TOTAIS_START',
    SELECT_VENDAS_TOTAIS_FINISH: 'SELECT_VENDAS_TOTAIS_FINISH',
    SELECT_VENDAS_TOTAIS_FAILED: 'SELECT_VENDAS_TOTAIS_FAILED',

    SELECT_VENDAS_DOS_NUCLEOS_START: 'SELECT_VENDAS_DOS_NUCLEOS_START',
    SELECT_VENDAS_DOS_NUCLEOS_FINISH: 'SELECT_VENDAS_DOS_NUCLEOS_FINISH',
    SELECT_VENDAS_DOS_NUCLEOS_FAILED: 'SELECT_VENDAS_DOS_NUCLEOS_FAILED',

    SELECT_VENDAS_POR_NUCLEOS_START: 'SELECT_VENDAS_POR_NUCLEOS_START',
    SELECT_VENDAS_POR_NUCLEOS_FINISH: 'SELECT_VENDAS_POR_NUCLEOS_FINISH',
    SELECT_VENDAS_POR_NUCLEOS_FAILED: 'SELECT_VENDAS_POR_NUCLEOS_FAILED',

    SELECT_VENDAS_POR_PRODUTOS_START: 'SELECT_VENDAS_POR_PRODUTOS_START',
    SELECT_VENDAS_POR_PRODUTOS_FINISH: 'SELECT_VENDAS_POR_PRODUTOS_FINISH',
    SELECT_VENDAS_POR_PRODUTOS_FAILED: 'SELECT_VENDAS_POR_PRODUTOS_FAILED',

    SELECT_PRODUCT_CATEGORIES_START: 'SELECT_PRODUCT_CATEGORIES_START',
    SELECT_PRODUCT_CATEGORIES_FINISH: 'SELECT_PRODUCT_CATEGORIES_FINISH',
    SELECT_PRODUCT_CATEGORIES_FAILED: 'SELECT_PRODUCT_CATEGORIES_FAILED',

    SELECT_ATTENDANCE_COLUMNS_START: 'SELECT_ATTENDANCE_COLUMNS_START',
    SELECT_ATTENDANCE_COLUMNS_FINISH: 'SELECT_ATTENDANCE_COLUMNS_FINISH',
    SELECT_ATTENDANCE_COLUMNS_FAILED: 'SELECT_ATTENDANCE_COLUMNS_FAILED',

    SELECT_COURSE_FOR_COURSEWARE: 'SELECT_COURSE_FOR_COURSEWARE',
    SELECT_EVENT_FOR_PARTICIPANTS: 'SELECT_EVENT_FOR_PARTICIPANTS',
    SELECT_EVENT_FOR_IMPORT: 'SELECT_EVENT_FOR_IMPORT',
    SELECT_RELATORIO: 'SELECT_RELATORIO',
    SELECT_CATEGORIA: 'SELECT_CATEGORIA',
    SELECT_NUCLEO: 'SELECT_NUCLEO',

    LIST_PRODUCTS_START: 'LIST_PRODUCTS_START',
    LIST_PRODUCTS_FINISH: 'LIST_PRODUCTS_FINISH',
    LIST_PRODUCTS_FAILED: 'LIST_PRODUCTS_FAILED',

    SELECT_PRODUCTS_START: 'SELECT_PRODUCTS_START',
    SELECT_PRODUCTS_FINISH: 'SELECT_PRODUCTS_FINISH',
    SELECT_PRODUCTS_FAILED: 'SELECT_PRODUCTS_FAILED',

    CREATE_CART_START: 'CREATE_CART_START',
    CREATE_CART_FINISH: 'CREATE_CART_FINISH',
    CREATE_CART_FAILED: 'CREATE_CART_FAILED',

    LIST_CART_ITEMS_START: 'LIST_CART_ITEMS_START',
    LIST_CART_ITEMS_FINISH: 'LIST_CART_ITEMS_FINISH',
    LIST_CART_ITEMS_FAILED: 'LIST_CART_ITEMS_FAILED',

    UPDATE_CART_START: 'UPDATE_CART_START',
    UPDATE_CART_FINISH: 'UPDATE_CART_FINISH',
    UPDATE_CART_FAILED: 'UPDATE_CART_FAILED',

    CLOSE_CART_START: 'CLOSE_CART_START',
    CLOSE_CART_FINISH: 'CLOSE_CART_FINISH',
    CLOSE_CART_FAILED: 'CLOSE_CART_FAILED',

    DELETE_CART_START: 'DELETE_CART_START',
    DELETE_CART_FINISH: 'DELETE_CART_FINISH',
    DELETE_CART_FAILED: 'DELETE_CART_FAILED',

    LIST_OPEN_ORDERS_START: 'LIST_OPEN_ORDERS_START',
    LIST_OPEN_ORDERS_FINISH: 'LIST_OPEN_ORDERS_FINISH',
    LIST_OPEN_ORDERS_FAILED: 'LIST_OPEN_ORDERS_FAILED',

    LIST_PAYMENT_METHODS_START: 'LIST_PAYMENT_METHODS_START',
    LIST_PAYMENT_METHODS_FINISH: 'LIST_PAYMENT_METHODS_FINISH',
    LIST_PAYMENT_METHODS_FAILED: 'LIST_PAYMENT_METHODS_FAILED',

    SELECT_OPEN_ORDER: 'SELECT_OPEN_ORDER',
    SELECT_CLOSED_ORDER: 'SELECT_CLOSED_ORDER',
    UPDATE_PAYMENT_SPLIT: 'UPDATE_PAYMENT_SPLIT',

    CLOSE_ORDER_START: 'CLOSE_ORDER_START',
    CLOSE_ORDER_FINISH: 'CLOSE_ORDER_FINISH',
    CLOSE_ORDER_FAILED: 'CLOSE_ORDER_FAILED',

    PRINT_ORDER_RECEIPT_START: 'PRINT_ORDER_RECEIPT_START',
    PRINT_ORDER_RECEIPT_FINISH: 'PRINT_ORDER_RECEIPT_FINISH',
    PRINT_ORDER_RECEIPT_FAILED: 'PRINT_ORDER_RECEIPT_FAILED',

    PRINT_ORDER_DELIVERY_START: 'PRINT_ORDER_DELIVERY_START',
    PRINT_ORDER_DELIVERY_FINISH: 'PRINT_ORDER_DELIVERY_FINISH',
    PRINT_ORDER_DELIVERY_FAILED: 'PRINT_ORDER_DELIVERY_FAILED',

    LIST_CLOSED_ORDERS_START: 'LIST_CLOSED_ORDERS_START',
    LIST_CLOSED_ORDERS_FINISH: 'LIST_CLOSED_ORDERS_FINISH',
    LIST_CLOSED_ORDERS_FAILED: 'LIST_CLOSED_ORDERS_FAILED',

    DELIVER_ORDER_START: 'DELIVER_ORDER_START',
    DELIVER_ORDER_FINISH: 'DELIVER_ORDER_FINISH',
    DELIVER_ORDER_FAILED: 'DELIVER_ORDER_FAILED',

    SHOW_SWAL: 'SHOW_SWAL',
    CLOSE_SWAL: 'CLOSE_SWAL',

    FIND_CLIENT_NAME_START: 'FIND_CLIENT_NAME_START',
    FIND_CLIENT_NAME_FINISH: 'FIND_CLIENT_NAME_FINISH',
    FIND_CLIENT_NAME_FAILED: 'FIND_CLIENT_NAME_FAILED',

    UPDATE_EMAIL_EDITOR: 'UPDATE_EMAIL_EDITOR',
    UPDATE_LOTTERY_CONFIG: 'UPDATE_LOTTERY_CONFIG',
    CONFIGURE_LOTTERY: 'CONFIGURE_LOTTERY',
    CLOSE_LOTTERY: 'CLOSE_LOTTERY',
    RUN_LOTTERY: 'RUN_LOTTERY',

    LIST_PAID_ORDERS_START: 'LIST_PAID_ORDERS_START',
    LIST_PAID_ORDERS_FINISH: 'LIST_PAID_ORDERS_FINISH',
    LIST_PAID_ORDERS_FAILED: 'LIST_PAID_ORDERS_FAILED',

    SELECT_PAID_ORDER: 'SELECT_PAID_ORDER',

    LIST_PARTICIPANTS_START: 'LIST_PARTICIPANTS_START',
    LIST_PARTICIPANTS_FINISH: 'LIST_PARTICIPANTS_FINISH',
    LIST_PARTICIPANTS_FAILED: 'LIST_PARTICIPANTS_FAILED',

    LIST_AMOUNT_BY_SLOT_START: 'LIST_AMOUNT_BY_SLOT_START',
    LIST_AMOUNT_BY_SLOT_FINISH: 'LIST_AMOUNT_BY_SLOT_FINISH',
    LIST_AMOUNT_BY_SLOT_FAILED: 'LIST_AMOUNT_BY_SLOT_FAILED',

    CREATE_LOTTERY_GAME_START: 'CREATE_LOTTERY_GAME_START',
    CREATE_LOTTERY_GAME_FINISH: 'CREATE_LOTTERY_GAME_FINISH',
    CREATE_LOTTERY_GAME_FAILED: 'CREATE_LOTTERY_GAME_FAILED',

    UPDATE_LOTTERY_GAME_START: 'UPDATE_LOTTERY_GAME_START',
    UPDATE_LOTTERY_GAME_FINISH: 'UPDATE_LOTTERY_GAME_FINISH',
    UPDATE_LOTTERY_GAME_FAILED: 'UPDATE_LOTTERY_GAME_FAILED',
};

export default ClientActionTypes;



// WEBPACK FOOTER //
// src/ActionTypes.js